import React from 'react';
import { MdEmail } from "react-icons/md";
import css from './icon.module.css'

export const emailIcon = ({ ariaLabel = 'Facebook' }) => {
  return (
    <MdEmail className={css.icon}/>
  );
};
